var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("emailsmslog-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "tile is-parent animated" }, [
                _c("article", { staticClass: "tile is-child box" }, [
                  _c("div", { staticClass: "columns" }, [
                    _c(
                      "div",
                      {
                        staticClass: "column is-fullwidth",
                        staticStyle: { overflow: "auto", width: "100px" },
                      },
                      [
                        _c(
                          "bulma-table",
                          {
                            staticClass:
                              "table is-bordered is-striped is-narrow is-fullwidth",
                            attrs: {
                              columns: _vm.columns,
                              "page-index": _vm.filter.pageIndex,
                              "page-size": _vm.filter.pageSize,
                              "total-rows": _vm.totalRows,
                              "is-loading": _vm.isTableLoading,
                              "sort-column": _vm.filter.sortColumn,
                              "sort-order": _vm.filter.sortOrder,
                            },
                            on: {
                              pageChanged: _vm.onPageChange,
                              sort: _vm.sort,
                            },
                          },
                          [
                            _vm._l(
                              _vm.entitySummaries,
                              function (entity, index) {
                                return _c(
                                  "tr",
                                  {
                                    key: entity.id,
                                    class: {
                                      "is-selected": _vm.selectedRow === index,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.highlightSelected(
                                          index,
                                          $event
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        class: {
                                          "has-text-primary":
                                            _vm.selectedRow !== index &&
                                            entity.assetType === "EMAIL",
                                          "has-text-danger":
                                            _vm.selectedRow !== index &&
                                            entity.assetType === "SMS",
                                          "has-text-dark":
                                            _vm.selectedRow === index,
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(entity.assetType))]
                                    ),
                                    _c("td", [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "icon is-small mr-1",
                                            },
                                            [
                                              _c("i", {
                                                class:
                                                  entity.direction ===
                                                  "Incoming"
                                                    ? "mdi mdi-call-received"
                                                    : "mdi mdi-call-made",
                                              }),
                                            ]
                                          ),
                                          _c("span", [
                                            _vm._v(_vm._s(entity.direction)),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                    _c("td", [_vm._v(_vm._s(entity.status))]),
                                    _c("td", { staticClass: "col-width" }, [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$filters.formatDateTimeLocale(
                                              entity.sentOn,
                                              _vm.$userInfo.locale
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("td", [_vm._v(_vm._s(entity.contact))]),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                path: `/quotes/${entity.quoteId}`,
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(entity.quoteNoRef) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("td", [_vm._v(_vm._s(entity.claimNo))]),
                                    _c("td", [_vm._v(_vm._s(entity.rego))]),
                                    _c("td", { staticClass: "col-message" }, [
                                      _c("div", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.generateUrl(entity.id),
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.edit(
                                                  entity.id,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  entity.messageHtml
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            _c("template", { slot: "empty" }, [
                              _c("section", { staticClass: "section" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content has-text-grey has-text-centered",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { icon: "icon is-large" } },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-48px mdi-emoticon-sad",
                                        }),
                                      ]
                                    ),
                                    _c("p", [_vm._v("Nothing")]),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }